import { AuthContextProvider } from '@backoffice-frontend/authentication'
import { Environment, getEnvironment } from '@backoffice-frontend/environment'
import { loadTranslations } from '@backoffice-frontend/login-view'
import {
  MoiaNotificationProvider,
  PickersUtilsProvider,
  SuspenseLoadingWrapper,
} from '@backoffice-frontend/patterns'
import { Outlet } from 'react-router'
import { AppUpdateToast } from './lib/AppUpdateToast'

const UserPoolClientIds: Record<Environment, string> = {
  [Environment.test]: 'local',
  [Environment.local]: 'local',
  [Environment.development]: '5a3jtd0ekdob0icf1mffp707cj',
  [Environment.integration]: '3rusooc4p8ofen1sc6i9m28c8n',
  [Environment.production]: '303i548r0d7rd5q2b2s9a178hj',
}

export const Layout = () => {
  loadTranslations()

  return (
    <AuthContextProvider userPoolClientId={UserPoolClientIds[getEnvironment()]}>
      <PickersUtilsProvider>
        <MoiaNotificationProvider>
          <AppUpdateToast />
          <SuspenseLoadingWrapper>
            <Outlet />
          </SuspenseLoadingWrapper>
        </MoiaNotificationProvider>
      </PickersUtilsProvider>
    </AuthContextProvider>
  )
}
